import { PersonaSize } from '@fluentui/react/lib/Persona';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const getPersonaSize = (
    isSingleLine: boolean,
    densityModeString: string
): PersonaSize.size16 | PersonaSize.size24 | PersonaSize.size28 | PersonaSize.size32 => {
    switch (densityModeString) {
        case 'compact':
            return PersonaSize.size16;
        case 'medium':
            return PersonaSize.size24;
        default:
            return isSingleLine ? PersonaSize.size28 : PersonaSize.size32;
    }
};

export const getPersonaSizeForMLRow = (
    isSingleLine: boolean,
    densityModeString: string
): PersonaSize.size16 | PersonaSize.size24 | PersonaSize.size28 | PersonaSize.size32 => {
    const isRPDenslessEnabled = isGlobalFeatureEnabled('mon-type-ramp');
    // In densless mode we want to use size28 for compact and size32 for medium, otherwise we will use the same sizes as before
    switch (densityModeString) {
        case 'compact':
            return isSingleLine
                ? PersonaSize.size16
                : isRPDenslessEnabled
                ? PersonaSize.size28
                : PersonaSize.size24;
        case 'medium':
            return isSingleLine
                ? PersonaSize.size24
                : isRPDenslessEnabled
                ? PersonaSize.size32
                : PersonaSize.size28;
        default:
            return isSingleLine ? PersonaSize.size28 : PersonaSize.size32;
    }
};
